
import {Component, Vue} from 'vue-property-decorator';
import {appName} from '@/env';
import {
  readDashboardMiniDrawer,
  readDashboardShowDrawer,
  readForms,
  readHasModuleAccess,
  readIsLoggedIn, readMenuForms, readUserProfile,
} from '@/store/main/getters';
import {
  commitAddNotification,
  commitSetDashboardMiniDrawer,
  commitSetDashboardShowDrawer,
} from '@/store/main/mutations';
import {dispatchGetMenuForms, dispatchUserLogOut} from '@/store/main/actions';
import AppToolbar from '@/components/AppToolbar.vue';
import AppDrawer from '@/components/AppDrawer.vue';
import {readFormCategories} from '@/store/admin/getters';
import {dispatchGetFormCategories} from '@/store/admin/actions';

const routeGuardMain = async (to, from, next) => {
  if (to.path === '/main') {
    next('/main/dashboard');
    // @ts-ignore

  } else if (!readHasModuleAccess(window.getApp.$store)(to.meta)) {
    // @ts-ignore
    commitAddNotification(window.getApp.$store, {content: window.getApp.lang('notAllowed'), color: 'warning'});
    next('/main/dashboard');
    // @ts-ignore
  } else {
    next();
  }
};

@Component({
  components: {AppToolbar, AppDrawer},
})
export default class Main extends Vue {
  public appName = appName;

  private get currentUser() {
    return readUserProfile(this.$store);
  }

  public beforeRouteEnter(to, from, next) {
    routeGuardMain(to, from, next);
  }

  public beforeRouteUpdate(to, from, next) {
    routeGuardMain(to, from, next);
  }

  public async mounted() {
    // if (!(await readIsLoggedIn(this.$store))) {
    //   return;
    // }

    if (!this.menuForms.length) {
        // @ts-ignore
        await dispatchGetMenuForms(this.$store);
        // if (await readUserProfile(this.$store)?.is_superuser) {
        //   await dispatchGetForms(this.$store);
        // } else {
        //   // @ts-ignore
        //   await dispatchGetForms(this.$store, {just_enabled: true});
        // }
      }
    if (!this.formCategories.length) {
      await dispatchGetFormCategories(this.$store);
    }
  }

  get menuForms() {
    return readMenuForms(this.$store);
  }

  get formCategories() {
    return readFormCategories(this.$store);
  }

  get miniDrawer() {
    return readDashboardMiniDrawer(this.$store);
  }

  get showDrawer() {
    return readDashboardShowDrawer(this.$store);
  }

  set showDrawer(value) {
    commitSetDashboardShowDrawer(this.$store, value);
  }

  public switchShowDrawer() {
    commitSetDashboardShowDrawer(
        this.$store,
        !readDashboardShowDrawer(this.$store),
    );
  }

  public switchMiniDrawer() {
    commitSetDashboardMiniDrawer(
        this.$store,
        !readDashboardMiniDrawer(this.$store),
    );
  }

  public async logout() {
    await dispatchUserLogOut(this.$store);
  }
}
